"use client"

import { useUser } from "@auth0/nextjs-auth0"
import mixpanel from "mixpanel-browser"
import { useEffect } from "react"

export function UserTracked() {
    const { user } = useUser()

    useEffect(() => {
        if (user && user.sub) {
            mixpanel.identify(user.sub)
        }
    }, [user])

    return <></>
}
